"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParseActionRouteParams = void 0;
const util_1 = require("./util");
const useParseActionRouteParams = () => {
    const params = util_1.parseActionRouteParams(window.location.search || {});
    return params || {};
};
exports.useParseActionRouteParams = useParseActionRouteParams;
exports.default = exports.useParseActionRouteParams;
